import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

type AppMetadata = {
  version?: string
}

@Injectable({
  providedIn: 'root',
})
export class VisionDisplayService {
  private _version?: string | undefined

  constructor(private httpClient: HttpClient) {}

  public loadVersion() {
    this.httpClient.get<AppMetadata>('/assets/app-metadata/package.json').subscribe(metadata => {
      this.version = metadata?.version
    })
  }

  public get version(): string | undefined {
    return this._version
  }
  public set version(value: string | undefined) {
    this._version = value
  }
}
